<template>
    <div class="main">
        <div class="header" @click="homeBack">
            <div class="back_icon"></div>返回首页
        </div>
        <div class="process">
            <div class="line"></div>
            <div :class="['item',{'isBorder':questionInfo.showQuestionNo-1 != index || item==0 || item==1}]" v-for="(item,index) in processList" :key="index">
                <div class="loading" v-if="questionInfo.showQuestionNo-1 == index && item==-1"></div>
                <div :class="{'item_success':item==1,'item_fail':item==0}"></div>
            </div>
        </div>
        <div class="question">
            <div class="time" :style="{'color':countdownColor(time)}">{{time}}</div>
            <div class="content">{{questionInfo.questionTitle}}</div>
            <div>
                <div class="btn_item" v-for="(item, key, index) in questionInfo.options" :key="index">
                    <div :class="['btn', {'btn_success':index==selectedNo||index==rightOption, 'btn_fail':index==selectedNo&&!isRight}]" @click="addAnswer(key,index)">
                        <span>{{item}}</span>
                        <span :class="['tips', {'tips_success':index==selectedNo||index==rightOption, 'tips_fail':index==selectedNo&&!isRight}]"></span>
                    </div>
                </div>
            </div>
        </div>
        <popup :userid="userid" :popType="popType" @usePop="usePop" @searchQuestion="searchQuestion" :questionInfo="questionInfo" :answerInfo="answerInfo" :prizeList="prizeList"></popup>
    </div>
</template>
<script>
import popup from '@/components/popup.vue'
import {addAnswer, searchPrizes, searchQuestion} from '@/api/index'
export default {
    name: 'question',
    components: {
        popup
    },
    data() {
        return {
            popType: 0, // 弹窗类型
            time: 15, // 倒计时
            timer: null, // 倒计时定时器
            isPass: false, // 回答是否正确
            userid: '', // 用户id
            questionInfo: {}, // 题目信息
            answerInfo: {}, // 答题信息
            processList: [-1,-1,-1,-1,-1], // 进度条
            isRight: true, // 当前是否答对
            selectedNo: -1, // 当前选中
            rightOption: -1, // 正确选项
            prizeList: [], // 奖品列表
            isNext: true, // 是否开始下一题
            timerCount: 0, // 当前题目序号
        }
    },
    created() {
        _hmt.push(["_trackEvent", "答题页", "答题页"]);
        this.userid = localStorage.userid || this.$route.query.userid
        if (this.userid) {
            this.searchQuestion(1)
            this.searchPrizes()
        }
        console.log('userid',this.userid)
    },
    beforeDestroy() {
        clearInterval(this.timer) 
    },
    methods: {
        // 返回首页
        homeBack() {
            this.$router.push({ path: '/' })
        },
        // 弹窗
        usePop(popType) {
            this.popType = popType
        },
        // 倒计时
        countdown() {
            this.timer = setInterval(() => {
                this.time --
                if (this.time == 0) {
                    clearInterval(this.timer)
                    this.addAnswer(-1, -1)
                }
            },1000)
        },
        // 倒计时颜色
        countdownColor(num) {
            if (num <= 3) {
                return 'rgba(254, 70, 82, 0.6)'
            } else if (num > 3 && num <=10) {
                return 'rgba(254, 70, 82, 0.8)'
            } else {
                return 'rgba(254, 70, 82, 1)'
            }
        },
        // 答题
        addAnswer(key, index) {
            // index==selectedNo||index==rightOption
            if (!this.isNext) return
            let params = {
                userid: this.userid,
                questionNo: this.questionInfo.questionNo,
                rightOption: key
            }

            addAnswer(params).then((res) => {
                this.selectedNo = index
                this.isNext = false
                clearInterval(this.timer)

                let obj = res.data.obj
                this.isRight = obj.isRight
                this.answerInfo = obj
                // 答对1题
                if (obj.isRight) {
                    this.processList[this.showQuestionNo-1] = 1
                } else {
                    this.processList[this.showQuestionNo-1] = 0

                    let options = {'A':0, 'B':1, 'C':2, 'D':3}
                    this.rightOption = options[obj.rightOption]
                    // console.log('正确选项',this.rightOption)
                }
                // 答完1题
                setTimeout(() => {
                    if (!obj.isFinishLevel) {
                        this.selectedNo = -1
                        this.rightOption = -1
                        this.searchQuestion()
                        this.countdown()
                    } else { // 答完5题
                        if (obj.isAllRight) {
                            if (obj.hasGetPrize) {
                                this.usePop(2)
                            } else {
                                this.usePop(9)
                            }
                        } else {
                            this.usePop(3)
                        }
                    }
                },1000)
            })
        },
        // 获取奖品
        searchPrizes() {
            let data = {
                userid: this.userid,
            }
            searchPrizes(data).then((res) => {
                let obj = res.data.obj
                this.prizeList = obj
                console.log('获取奖品列表', obj)
            })
        },
        // 获取题目信息
        searchQuestion(flushQ) {
            let _this = this
            let params = {
                userid: this.userid,
            }
            if (flushQ == 1) {
                params.flushQ = 1
                this.processList = [-1,-1,-1,-1,-1]
                this.countdown()
            }
            searchQuestion(params).then((res) => {
                let obj = res.data.obj
                this.questionInfo = obj
                this.showQuestionNo = obj.showQuestionNo
                // 操作重置
                this.selectedNo = -1
                this.rightOption = -1
                this.isNext = true
                this.time = 15
                // console.log('获取题目信息', obj)
            })
        }
    },
}
</script>
<style lang="scss" scoped>
    .main {
        margin: 0 auto;
        background: url(../assets/images/question_bg.jpg) no-repeat;
        background-size: cover;
        min-height: 100vh;
        overflow: auto;
        .header {
            width: 2rem;
            height: 0.3rem;
            color: #fff;
            font-size: 0.3rem;
            margin: 0.2rem;
            .back_icon {
                width: 0.15rem;
                height: 0.3rem;
                background: url(../assets/images/back.png) no-repeat;
                background-size: contain;
                background-position: left;
                display: inline-block;
                vertical-align: middle;
                margin-right: 0.1rem;
            }
        }
        .process {
            display: flex;
            justify-content: space-between;
            color: #fff;
            width: 6.6rem;
            margin: 1rem auto 0.5rem;
            .line {
                width: 6.6rem;
                height: 1px;
                border-top: 1px solid #fff;
                position: absolute;
            }
            .item {
                width: 0.4rem;
                height: 0.4rem;
                border-radius: 50%;
                display: inline-block;
                position: relative;
                top: -0.2rem;
                background: #FE434E;
                .loading {
                    width: 0.4rem;
                    height: 0.4rem;
                    background: url(../assets/images/loading.png) no-repeat;
                    background-size: contain;
                    animation: loading 3s infinite linear;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }
            .isBorder{
                border: 1px solid #fff;
            }
            .item_success {
                width: 0.4rem;
                height: 0.4rem;
                background: url(../assets/images/success_q.png) no-repeat;
                background-size: contain;
                position: absolute;
                left: -1px;
                top: -2px;
            }
            .item_fail {
                width: 0.4rem;
                height: 0.4rem;
                background: url(../assets/images/fail_q.png) no-repeat;
                background-size: contain;
                position: absolute;
                left: -1px;
                top: -2px;
            }
        }
        .question {
            width: 6.6rem;
            height: 8.8rem;
            background: url(../assets/images/question_bg.png) no-repeat;
            background-size: contain;
            margin: 0 auto;
            position: relative;
            .time {
                color: #FE4652;
                font-size: 0.54rem;
                padding-top: 0.3rem;
            }
            @keyframes loading {
                from {
                    transform: rotate(0deg);
                }
                to {
                    transform: rotate(360deg);
                }
            }
            .content {
                width: 6rem;
                height: 1.6rem;
                overflow: auto;
                margin: 0 auto;
                margin-top: 0.4rem;
                text-align: left;
            }
            .btn_item {
                width: 6rem;
                height: 0.9rem;
                display: flex;
                margin: 0.3rem auto;
            }
            .btn {
                width: 6rem;
                height: 0.9rem;
                color: #333;
                background: rgba(211, 211, 211, 0.55);
                border-radius: 0.5rem;
                margin: 0.3rem auto;
                position: relative;
                word-break: break-all;
                align-items: center;
                display: flex;
                text-align: center;
                justify-content: center;
                padding: 0 0.2rem;
                .tips {
                    width: 0.3rem;
                    height: 0.3rem;
                    position: absolute;
                    right: 0.1rem;
                    top: 0.35rem;
                }
                .tips_success {
                    background: url(../assets/images/success.png) no-repeat;
                    background-size: contain;
                }
                .tips_fail {
                    background: url(../assets/images/fail.png) no-repeat;
                    background-size: contain;
                }
            }
            .btn_success {
                background-image: linear-gradient(to right, #FF6047, #E01D20 );
                color: #fff;
            }
            .btn_fail {
                background-image: linear-gradient(to right, #93CEFC, #1F88D9 );
                color: #fff;
            }
        }
    }
</style>